export default {
  name: 'marking--erpH',
  apiService: 'shoes',
  apiPath: '/admin/doc_erp_h',
};